/// <amd-module name="SuiteCommerce.MapAndContactUs.Utils"/>
define("SuiteCommerce.MapAndContactUs.Utils", ["require", "exports", "SuiteCommerce.MapAndContactUs.Common.DependencyProvider"], function (require, exports, DependencyProvider_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = void 0;
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.getAbsoluteUrl = function (file, isServices2) {
            return DependencyProvider_1.UtilsModule.getAbsoluteUrl(file, isServices2);
        };
        Utils.translate = function (text) {
            return DependencyProvider_1.UtilsModule.translate(text);
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
